module.exports = __webpack_public_path__ + "img/1479559103.6ff36136.jpg";